
import { AccountController } from "@/app/ui/controllers/AccountController";
import { Options, prop, Vue } from "vue-class-component";
class Props {
  flag = prop<string>({
    type: String,
    default: "",
  });
}
@Options({
  components: {},
})
export default class POD extends Vue.with(Props) {
  get isAccountForeign() {
    return AccountController.accountData?.accountIsForeign;
  }
}
